// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"240":"e2433aa4","306":"702b8cb2","488":"0af9e323","616":"2e9a6a15","632":"d8b28814","665":"107415cb","732":"3e035bac","739":"34e98700","817":"b16381eb","848":"bb524900","955":"699f13eb"}[chunkId] + ".chunk.js";
};